import { useCallback, useEffect, useState } from "react";
import { platformClient } from "./platformApi";
import { PlatformLogin } from "./PlatformLogin";
import { PlatformAdmin } from "./PlatformAdmin";
import { PlatformHome } from "./PlatformHome";

const IDLE_LIMIT_MS = 30 * 60 * 1000;
const IDLE_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

export default function PlatformApp() {
    const [auth, setAuth] = useState(null);
    const [idleNotice, setIdleNotice] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await platformClient.get("/auth/me");
                setAuth(data);
            } catch {
                setAuth(false);
            }
        })();
    }, []);

    const logout = useCallback(async () => {
        try {
            await platformClient.post("/auth/logout");
        } catch {}
        setAuth(false);
    }, []);

    // Automatisch uitloggen na 30 minuten inactiviteit
    useEffect(() => {
        if (!auth) return undefined;
        let timer;
        const reset = () => {
            clearTimeout(timer);
            timer = setTimeout(async () => {
                try {
                    await platformClient.post("/auth/logout");
                } catch {}
                setIdleNotice(true);
                setAuth(false);
            }, IDLE_LIMIT_MS);
        };
        IDLE_EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
        reset();
        return () => {
            clearTimeout(timer);
            IDLE_EVENTS.forEach((e) => window.removeEventListener(e, reset));
        };
    }, [auth]);

    const refresh = useCallback(async () => {
        try {
            const { data } = await platformClient.get("/auth/me");
            setAuth(data);
        } catch {
            setAuth(false);
        }
    }, []);

    if (auth === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-ink">
                <p className="text-xs uppercase tracking-[0.3em] text-ash">Laden…</p>
            </div>
        );
    }
    if (auth === false) {
        return (
            <PlatformLogin
                onLogin={(data) => {
                    setIdleNotice(false);
                    setAuth(data);
                }}
                notice={idleNotice ? "Je bent automatisch uitgelogd omdat je 30 minuten niets hebt gedaan. Log opnieuw in om verder te gaan." : ""}
            />
        );
    }
    if (auth.role === "admin") {
        return <PlatformAdmin user={auth} onLogout={logout} onRefresh={refresh} />;
    }
    return <PlatformHome user={auth} onLogout={logout} onRefresh={refresh} />;
}
